// Card.js
import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import NativeShare from "./NativeShare";
import ShareSVG from "./ShareSVG";

const Card = ({
  folderName,
  assetDate,
  folderPaths,
  folderId,
  togglePopup,
}) => {
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 500,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <Link
      to={`/gallery/${encodeURIComponent(folderId)}${window.location.search}`}
      className="gal_link"
    >
      <div className="card_box">
        <div className="image_slider">
          {folderPaths && (
            <Slider {...settings}>
              {typeof folderPaths === "object" && Array.isArray(folderPaths) ? (
                folderPaths.map((imagePath, index) => (
                  <div key={index}>
                    <img
                      src={`https://new-dam-java.b-cdn.net/${imagePath}`}
                      className="img_banner"
                      alt=""
                    />
                  </div>
                ))
              ) : (
                <img
                  src={`https://new-dam-java.b-cdn.net/${folderPaths}`}
                  className="img_banner"
                  alt=""
                />
              )}
            </Slider>
          )}
        </div>

        <div className="card_content">
          <h5>{folderName}</h5>
          <div className="share_card_flex">
          <h6>
            <span>Folder</span> - <span>{assetDate}</span>
          </h6>
          <NativeShare id={folderId} folderName={folderName} togglePopup={() => togglePopup(folderId, folderName)}>
                <ShareSVG/>
              </NativeShare>
            </div>
        </div>
      </div>
    </Link>
  );
};

export default Card;
